import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DeploymentModel, ModelService, PersonaModel, ReasoningEffort} from 'digiteq-ai-portal-client-lib';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {FormUtils} from '../../utils/form-utils';

@Component({
  selector: 'app-persona-dialog',
  templateUrl: './persona-dialog.component.html',
  styleUrl: './persona-dialog.component.scss'
})
export class PersonaDialogComponent implements OnInit {
  @Input() editedItem: PersonaModel | null = null;
  @Input() processing: boolean = false;

  @Output() onCancel = new EventEmitter<void>();
  @Output() onAddPersona = new EventEmitter<PersonaModel>();
  @Output() onEditPersona = new EventEmitter<PersonaModel>();

  newPersonaForm?: FormGroup;
  models: DeploymentModel[] | undefined;
  maxTokens: number = 4000;

  protected readonly reasoningEffortLevelOptions: { label: string; value: ReasoningEffort }[] =
    Object.entries(ReasoningEffort).map(([label, value]) => ({
      label,
      value,
    }));

  constructor(
    private readonly fb: FormBuilder,
    private readonly messageService: MessageService,
    private readonly modelService: ModelService,
  ) { }

  ngOnInit(): void {
    this.newPersonaForm = this.fb.group({
      name: [this.editedItem?.name || '', Validators.required],
      enabled: [this.editedItem?.enabled || true],
      deploymentId: [this.editedItem?.deploymentId || null, Validators.required],
      prompt: [this.editedItem?.prompt || '', Validators.required],
      maxTokens: [
        {
          value: this.editedItem?.maxTokens || '',
          disabled: !this.editedItem?.maxTokens,
        },
        Validators.required
      ],
      lastMessages: [this.editedItem?.lastMessages || null, Validators.required],
      default: [this.editedItem?.default || false,  Validators.required],
      reasoningEffortLevel: [this.editedItem?.reasoningEffortLevel || 'medium', Validators.required],
    })
    if (this.editedItem?.id) {
      this.newPersonaForm.addControl('id', this.fb.control(this.editedItem.id));
    }

    this.modelService.getAllModels().subscribe((models) => {
      this.models = models.filter(item => item.enabled)
      if (this.editedItem?.deploymentId) {
        this.maxTokens = this.models.find((model) => model.id === this.editedItem?.deploymentId)?.maxResponseTokens;
      }

      this.newPersonaForm.controls.deploymentId.valueChanges.subscribe((deploymentId) => {
        if (deploymentId) {
          this.newPersonaForm.get('maxTokens')?.enable();
          this.maxTokens = this.models.find((model) => model.id === deploymentId)?.maxResponseTokens;
        } else {
          this.newPersonaForm.get('maxTokens')?.disable();
        }
      })
    })
  }

  onDialogCancel() {
    this.newPersonaForm?.reset();
    this.onCancel.emit();
  }

  onSubmit() {
    if (!FormUtils.checkIfFormGroupValid(this.newPersonaForm, this.messageService)) {
      return;
    }

    if (!this.editedItem) {
      this.createPersona(this.newPersonaForm?.value);
    } else  {
      this.updatePersona(this.newPersonaForm?.value);
    }

  }

  createPersona(persona: PersonaModel | undefined) {
    if (!persona) return;
    this.onAddPersona.emit(persona);
  }

  updatePersona(persona: PersonaModel | undefined) {
    if (!persona) return;
    this.onEditPersona.emit(persona);
  }
}
